import { requestPost } from '../../../utils/request';
import { shouldUseMockWithoutSeasonData } from '../../../utils/mocks';
import { parseHarvestSeasons } from './selectors';

const BASE_PATH = '/api/rogue/v3/postharvestadjustedyield/';

// @TODO: Remove once Rogue and Cyclops have CORS support
// Use an empty string for the root URL. This is needed because Rogue and Cyclops do not have
// CORS support. This will cause the current hostname to be used in the request URLs.
const ROOT_URL = '';

/**
 * Request Harvest analytics
 * @param {String} fieldUUID
 * @param {String} userId
 * @return {Promise} Response
 */
export async function requestHarvestSeasons(fieldUUID, userId) {

  const mockFile = shouldUseMockWithoutSeasonData()
    ? 'harvest/noData'
    : 'harvest/default';

  const response = await requestPost(BASE_PATH, {
    mockFile,
    rootUrl: ROOT_URL,
    headers: {
      'x-user-id': userId,
    },
    data: {
      fieldUUIDs: [fieldUUID],
    },
  });

  // Format and return the results
  return {
    postHarvestYields: parseHarvestSeasons(response.postHarvestYields),
  };
}
